/**
 * Sessão do lado do navegador: um token trocado pela senha no login.
 *
 * Guardado em localStorage para sobreviver a F5 e a novas abas — a demo abre
 * a linha e o console em abas separadas, e logar duas vezes seria ruído.
 */

const KEY = 'cobai_token'

export const getToken = (): string | null => window.localStorage.getItem(KEY)

export const setToken = (token: string): void => window.localStorage.setItem(KEY, token)

export const clearToken = (): void => window.localStorage.removeItem(KEY)
